import loadingGif from '../../../assets/img/loading.gif';
import React, { useState, useEffect, Fragment } from "react";
import axios from 'axios';
import AuthService from '../../../Auth/AuthService.js';
import { settings } from '../../../Helpers/Settings.js';
import { decodeToken, isExpired } from "react-jwt";
import "react-toastify/dist/ReactToastify.css";

function GridSonuc({projeId}) {
    const [loading, setLoading] = useState(false);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(/*null*/ true);

    const [data, setData] = useState([]);

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);

            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    useEffect(() => {
        getAcilisData();
    }, []);

    useEffect(() => {
        if (yetkiGor === true) {
            getData();
        }
    }, [projeId]);

    const getAcilisData = async () => {
        if (tokenYenile() === false) {
            return;
        }

        //const apiurl = process.env.REACT_APP_API_URL;

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("ERP - Projeler - Gör");

        setYetkiGor(tempYetkiGor);
    }

    const getData = async () => {
        try {
            setLoading(true);

            const res = await axios.get(settings.ApiUrl + 'Proje/GetProjeSonucList/' + projeId, { headers: AuthService.getHeaders() });

            if (res) {
                setData(res.data.value);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Fragment>
            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <React.Fragment>
                                {
                                    loading ?
                                        <div className="progressBackground">
                                            <div className="progressPopup">
                                                <img alt="Bekleyiniz..." src={loadingGif} />
                                            </div>
                                        </div>
                                        :
                                        ''
                                }
                                <div className="card">
                                    <div className="card-body mt-4">
                                        <div className="table-responsive" style={{maxHeight:"calc(100vh - 384px)"}}>
                                            <table className="table table-bordered table-hover table-sm mb-0" style={{fontSize:"0.7rem"}}>
                                                <thead>
                                                    <tr>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"center", width:"5%"}}>Türü</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"center", width:"5%"}}>Alt Türü</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"center", width:"10%"}}>Firma</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"center", width:"20%"}}>Konusu</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"center", width:"5%"}}>Parça No</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"center", width:"10%"}}>Ürün Kodu</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"center", width:"5%"}}>Renk Kodu</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"center", width:"5%"}}>Ölçü Birimi</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"center", width:"5%"}}>Miktar</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"center", width:"5%"}}>Kur</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"right", width:"5%"}}>Fiyat</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"right", width:"5%"}}>Tutar</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"right", width:"5%"}}>Ödenen</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"right", width:"5%"}}>Kalan</th>
                                                        <th style={{top:"-1px", position:"sticky", zIndex:"1000", textAlign:"center", width:"5%"}}>Durumu</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        data && data.length > 0 ?
                                                            data.map((item, index) => {
                                                                return (
                                                                    <React.Fragment>
                                                                        <tr key={index}>
                                                                            <td style={{textAlign:"center", backgroundColor:item.color}}>{ item.tur } </td>
                                                                            <td style={{textAlign:"center", backgroundColor:item.color}}>{ item.altTur } </td>
                                                                            <td style={{textAlign:"center", backgroundColor:item.color}}>{ item.cari } </td>
                                                                            <td style={{textAlign:"center", backgroundColor:item.color}}>{ item.malzeme } </td>
                                                                            <td style={{textAlign:"center", backgroundColor:item.color}}>{ item.parcaNo } </td>
                                                                            <td style={{textAlign:"center", backgroundColor:item.color}}>{ item.malzemeKodu } </td>
                                                                            <td style={{textAlign:"center", backgroundColor:item.color}}>{ item.renkKodu } </td>
                                                                            <td style={{textAlign:"center", backgroundColor:item.color}}>{ item.olcuBirimi } </td>
                                                                            <td style={{textAlign:"center", backgroundColor:item.color}}>{ item.miktar } </td>
                                                                            <td style={{textAlign:"center", backgroundColor:item.color}}>
                                                                                {
                                                                                    item.kur.toLocaleString('tr-TR', {minimumFractionDigits:4, maximumFractionDigits:4})
                                                                                }
                                                                            </td>
                                                                            <td style={{textAlign:"right", backgroundColor:item.color, whiteSpace:"pre-line"}}>
                                                                                {
                                                                                    item.paraBirimi + item.fiyat.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                                    "₺" + item.fiyatTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                                }
                                                                            </td>
                                                                            <td style={{textAlign:"right", backgroundColor:item.color, whiteSpace:"pre-line"}}>
                                                                                {
                                                                                    item.paraBirimi + item.tutar.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                                    "₺" + item.tutarTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                                }
                                                                            </td>
                                                                            <td style={{textAlign:"right", backgroundColor:item.color, whiteSpace:"pre-line"}}>
                                                                                {
                                                                                    item.paraBirimi + item.odenen.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                                    "₺" + item.odenenTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                                }
                                                                            </td>
                                                                            <td style={{textAlign:"right", backgroundColor:item.color, whiteSpace:"pre-line"}}>
                                                                                {
                                                                                    item.paraBirimi + item.kalan.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '\r\n' +
                                                                                    "₺" + item.kalanTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                                }
                                                                            </td>
                                                                            <td style={{textAlign:"center", backgroundColor:item.color}}>{ item.kapali === true ? "Kapalı" : "Açık" }</td>
                                                                        </tr>
                                                                    </React.Fragment>
                                                                )
                                                            })
                                                            :
                                                            <tr>
                                                                <td align="center" colSpan="15" style={{height:"48px"}}>
                                                                    Kayıt yok
                                                                </td>
                                                            </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        :
                        ""
            }
        </Fragment>
    );
};

export default GridSonuc;